import React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";

// Define a functional component named CountrySelector
// This component displays a country name and its flag as a link
const CountrySelector = ({ countryName, flagUrl, countryLink }) => {
  return (
    /* Link to the country-specific page */
    <div className="country-selector">
      <a
        className="country-link"
        href={countryLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        {/* Display the country's flag */}
        <img className="flag" src={flagUrl} alt={`${countryName} Flag`} />{" "}
        {/* Display the country name */}
        <Typography variant="body1" component="span" fontWeight="bold">
          {countryName}
        </Typography>
      </a>
    </div>
  );
};

// Define the expected prop types for the component
CountrySelector.propTypes = {
  countryName: PropTypes.string.isRequired,
  flagUrl: PropTypes.string.isRequired,
  countryLink: PropTypes.string.isRequired,
};

// Export the component as the default export
export default CountrySelector;
